'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDisabledCover = exports.ButtonInner = exports.ButtonIcon = exports.ButtonContent = exports.ButtonLabel = exports.Button = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  border: 0;\n  padding: 0;\n  background: none;\n  font-size: ', 'px;\n  font-family: ', ';\n  text-decoration: none;\n  display: inline-block;\n  outline: none;\n  vertical-align: middle;\n  line-height: initial;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  position: relative;\n  border: 0;\n  padding: 0;\n  background: none;\n  font-size: ', 'px;\n  font-family: ', ';\n  text-decoration: none;\n  display: inline-block;\n  outline: none;\n  vertical-align: middle;\n  line-height: initial;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  white-space: nowrap;\n  padding: ', ';\n  margin: 0 auto;\n'], ['\n  white-space: nowrap;\n  padding: ', ';\n  margin: 0 auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 0 4px;\n  border-radius: 4px;\n  border: 1px solid ', ';\n  overflow: hidden;\n  color: ', ';\n  background: ', ';\n  transition-property: background-color, border-color, color;\n  transition-duration: .3s;\n\n  ', '\n'], ['\n  padding: 0 4px;\n  border-radius: 4px;\n  border: 1px solid ', ';\n  overflow: hidden;\n  color: ', ';\n  background: ', ';\n  transition-property: background-color, border-color, color;\n  transition-duration: .3s;\n\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  text-align: center;\n  width: 2em;\n  font-size: ', 'px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  text-align: center;\n  width: 2em;\n  font-size: ', 'px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n\n  ', '\n'], ['\n  display: flex;\n  justify-content: space-between;\n\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n'], ['\n  border-radius: 4px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../../utils');

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  extraSmall: '7px 12px 6px',
  compact: '9px 16px 8px',
  small: '11px 20px 10px',
  default: '17px 36px 15px',
  medium: '17px 36px 15px'
};

var Button = exports.Button = _styledComponents2.default.button(_templateObject, function (props) {
  return props.theme.size['3'];
}, function (props) {
  return props.theme.font.bold;
}, (0, _helpers.boolStyle)('block', 'width: 100%; display: block;'), function (props) {
  return !props.disabled && '\n    &:hover{\n      > .button-content {\n        border-color: ' + (0, _helpers.darkenColor)(props.theme.color.border) + ';\n      }\n    }\n  ';
}, function (props) {
  if (props.variant && !props.disabled) {
    return '\n        &:hover {\n          > .button-content {\n            border-color: ' + (0, _helpers.darkenColor)(props.theme.color[props.variant]) + ';\n            background: ' + (0, _helpers.darkenColor)(props.theme.color[props.variant]) + ';\n          }\n        }\n      ';
  }

  return '';
});

Button.displayName = 'Button';
var ButtonLabel = exports.ButtonLabel = _styledComponents2.default.span(_templateObject2, (0, _helpers.getStyle)(sizes, 'size'));

ButtonLabel.displayName = 'ButtonLabel';
var ButtonContent = exports.ButtonContent = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.labelVariant ? props.theme.color[props.labelVariant] : props.theme.color.base2;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  if (props.variant && props.outlined) {
    return '\n        background: ' + props.theme.color.white + ';\n        border-color: ' + props.theme.color[props.variant] + ';\n        color: ' + props.theme.color[props.variant] + ';\n\n        .icon {\n          fill: ' + props.theme.color[props.variant] + ';\n        }\n\n        &:hover {\n          color: ' + props.theme.color[props.variant] + ';\n\n          .icon {\n            fill: ' + props.theme.color[props.variant] + ';\n          }\n\n          border-color: ' + (0, _helpers.darkenColor)(props.theme.color[props.variant]) + ';\n          background: ' + props.theme.color.white + ';\n        }\n      ';
  }

  if (props.variant && !props.outlined) {
    return '\n        background: ' + props.theme.color[props.variant] + ';\n        border-color: ' + props.theme.color[props.variant] + ';\n        color: ' + props.theme.color.white + ';\n\n        .icon {\n          fill: ' + props.theme.color.white + ';\n        }\n      ';
  }

  return '';
});

ButtonContent.displayName = 'ButtonContent';
var ButtonIcon = exports.ButtonIcon = _styledComponents2.default.span(_templateObject4, function (props) {
  return props.insideIconSize;
});

ButtonIcon.displayName = 'ButtonIcon';
var ButtonInner = exports.ButtonInner = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.loading && '\n    visibility: hidden;\n  ';
});

ButtonInner.displayName = 'ButtonInner';
var ButtonDisabledCover = exports.ButtonDisabledCover = (0, _styledComponents2.default)(_utils.DisableCover)(_templateObject6);
ButtonDisabledCover.displayName = 'ButtonDisabledCover';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button/styles.js
// module id = 2890
// module chunks = 4